<template>
  <div>
    <Card>
      <Row>
        <Button type="info" @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate
        :columns="columns"
        :data="product_unit_switches"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
    <Modal v-model="modalShow" :loading="modalLoading" @on-ok="handleSubmit" :title="formType === 'edit' ? $t('pages_product_switch_index_742') : $t('pages_product_switch_index_743')">
      <Form ref="product_unit_switch" :rules="rules" :model="product_unit_switch" :label-width="80">
        <Form-item :label="$t('pages_product_switch_index_744')" prop="big_product_id">
          <Input v-if="formType === 'edit' && product_unit_switch.big_product_name" type='text' v-model="show_big_product_name" />
          <Select
            v-else
            ref="big_product_id"
            v-model="product_unit_switch.big_product_id"
            :placeholder='$t("pages_product_switch_index_745")'
            filterable
            clearable
            :remote-method="searchProduct"
            :loading="loading">
            <Option v-for="(option, index) in products" :value="option.id" :key="index">{{option.name}}（{{option.unit}}）</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_product_switch_index_746')" prop="small_product_id" class='targetProduct'>
          <InputNumber :min="1" v-model="product_unit_switch.rate" :placeholder="$t('pages_product_switch_index_747')" />
          <span>X</span>
          <Input v-if="formType === 'edit' && product_unit_switch.small_product_name" type='text' v-model="show_small_product_name" />
          <Select
            v-else
            ref="small_product_id"
            v-model="product_unit_switch.small_product_id"
            :placeholder='$t("pages_product_switch_index_748")'
            filterable
            clearable
            :remote-method="searchProduct"
            :loading="loading">
            <Option v-for="(option, index) in products" :value="option.id" :key="index">{{option.name}}（{{option.unit}}）</Option>
          </Select>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 100
        },
        {
          title: i18n.t('pages_product_switch_index_744'),
          key: 'big_product_name',
          render: (h, params) => {
            const { big_product_name, big_product_unit } = params.row
            return h('span', {}, `${big_product_name}（${big_product_unit}）`)
          }
        },
        {
          title: i18n.t('pages_product_switch_index_746'),
          key: 'small_product_name',
          render: (h, params) => {
            const { rate, small_product_name, small_product_unit } = params.row
            return h('span', {}, `${rate} X ${small_product_name}（${small_product_unit}）`)
          }
        },
        {
          title: i18n.t('pages_product_switch_index_749'),
          key: 'updated_at'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ],
      rules: {
        big_product_id: { required: true, message: i18n.t('pages_product_switch_index_745') },
        rate: { required: true, message: i18n.t('pages_product_switch_index_750') },
        small_product_id: { required: true, message: i18n.t('pages_product_switch_index_750') },
      },
      modalLoading: true
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapGetters('product_unit_switch', ['product_unit_switch', 'product_unit_switches', 'meta', 'loading']),
    ...mapGetters('product', {
      products: 'products',
      productLoading: 'loading'
    }),
    show_big_product_name: {
      set (newV) {
        this.product_unit_switch.big_product_name = newV
        this.product_unit_switch.big_product_unit = ''
        if (!newV) {
          this.product_unit_switch.big_product_id = ''
          this.$refs.big_product_id.focus()
        }
      },
      get () {
        const { big_product_name, big_product_unit } = this.product_unit_switch
        return `${big_product_name}${big_product_unit ? `（${big_product_unit}）` : ''}`
      }
    },
    show_small_product_name: {
      set (newV) {
        this.product_unit_switch.small_product_name = newV
        this.product_unit_switch.small_product_unit = ''
        if (!newV) {
          this.product_unit_switch.small_product_id = ''
          this.$refs.small_product_id.focus()
        }
      },
      get () {
        const { small_product_name, small_product_unit } = this.product_unit_switch
        return `${small_product_name}${small_product_unit ? `（${small_product_unit}）` : ''}`
      }
    }
  },
  methods: {
    ...mapActions('product_unit_switch', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapActions('product', {
      getProducts: 'index'
    }),
    ...mapMutations('product_unit_switch', ['changeQuery']),
    ...mapMutations('product', {
      changeProductQuery: 'changeQuery',
      resetProductQuery: 'resetQuery'
    }),
    changePage (page) {
      this.changeQuery({ page })
      this.index()
    },
    searchProduct (query) {
      this.resetProductQuery()
      this.changeProductQuery({ query })
      this.getProducts()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      this.$refs.product_unit_switch.validate(async valid => {
        if (valid) {
          const { big_product_id, small_product_id } = this.product_unit_switch
          if (big_product_id === small_product_id) {
            this.modalLoading = false
            this.$nextTick(() => (this.modalLoading = true))
            return this.$Message.warning(i18n.t('pages_product_switch_index_751'))
          }
          if (this.formType === 'edit') {
            await this.update(this.product_unit_switch)
          } else if (this.formType === 'new') {
            await this.create(this.product_unit_switch)
          }
          this.modalShow = false
        } else {
          this.modalLoading = false
          this.$nextTick(() => (this.modalLoading = true))
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="less">
  .targetProduct .ivu-form-item-content {
    display: flex;
    flex-direction: row;
    .ivu-input-number {
      width: 130px;
    }
    span {
      margin: 0 15px;
    }
  }
</style>
